import React from 'react';

interface PaneContainerProps {
  /**
   * 子要素
   */
  children: React.ReactNode;
  /**
   * 追加のCSSクラス
   */
  className?: string;
  /**
   * インラインスタイル
   */
  style?: React.CSSProperties;
  /**
   * デフォルトのスタイルを適用しない場合はtrue
   */
  noDefaultStyle?: boolean;
}

/**
 * ペインのコンテナコンポーネント
 *
 * Two/ThreeColumnレイアウトで使用されるペイン内のコンテンツを包むためのコンテナ
 */
const PaneContainer: React.FC<PaneContainerProps> = ({
  children,
  className = '',
  style = {},
  noDefaultStyle = false
}) => {
  const baseClasses = noDefaultStyle ? '' : 'h-full pt-2 w-full border-none';

  return (
    <div
      className={`${baseClasses} ${className}`}
      style={style}
    >
      {children}
    </div>
  );
};

export default PaneContainer;
